import request from '../../../common/request/index.js'
const api = request.api

export default {
  export: (params) => api.post('role/role/export', params, { responseType: 'blob' }),
}